<template>
  <div id="confirmation" class="">
    <div class="c-infobox text-center">
      <h1>
        <b>{{ $t("lang.label_email_verification_success_title") }}</b>
      </h1>
      <p>
        {{ $t("lang.label_email_verification_success_text") }}
      </p>
      <p>
        <router-link to="/login">{{ $t("lang.label_signIn") }}</router-link>
      </p>
    </div>
  </div>
</template>
<script>
import API from "@/api";
import ServerResponse from "@/store/ServerResponse";
export default {
  name: "VerifyEmailAddress",
  data() {
    return {
      message: "",
      user: "",
      token: ""
    };
  },
  methods: {
    verify() {
      API.verifyMailAddress(this.$route.query.token)
        .then(() => {
        })
        .catch(error => {
          this.$router.push({
            name: "error",
            params: { serverResponse: new ServerResponse(error.response.data)}
          });
        });
    }
  },
  mounted() {
    this.verify();
  }
};
</script>
